/* eslint-disable no-console */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../Core/Components/Modal/CustomModal";
import CustomRoundedImage from "../../Core/Components/CustomRoundedImage";
import CloseIcon from "../../Common/Svgs/CloseIcon";
import Button from "../../Core/Components/CustomButton";
import { updateSession } from "../../Redux/Slices/sessions.slice";
import {
  getPowerAfricaKPI,
  getAssets,
  unretireAsset,
  getAllAssets,
} from "../../Redux/APIs/powerAfricaAPI";
import UnRetireIcon from "../../Common/Svgs/UnRetireIcon";

const LOCAL_DEFAULT_LIMIT = 10;

const UnretireAssetModal = ({
  visible,
  onCancel,
  currentPage,
  setCurrentPage,
}) => {
  const dispatch = useDispatch();

  const { currentAsset } = useSelector((state) => state.powerAfrica);

  const onConfirm = async () => {
    await dispatch(unretireAsset({ powerAfricaAssetId: currentAsset.id }));

    const response = await dispatch(
      getAssets({
        offset: ((currentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
      }),
    );

    // If no records exist for the current page, move to the previous page
    if (!response.payload.result.length && currentPage > 1) {
      const previousPage = currentPage - 1;
      setCurrentPage(previousPage);

      await dispatch(
        getAssets({
          offset: (previousPage - 1) * LOCAL_DEFAULT_LIMIT,
        }),
      );
    }

    dispatch(getPowerAfricaKPI());
    dispatch(getAllAssets());

    dispatch(
      updateSession({
        key: "showToastMessage",
        value: {
          visible: true,
          data: {
            title: "1 Asset Un-Retired",
            description: `Asset ${currentAsset?.registrationNo} was un-retired for successfully`,
          },
        },
      }),
    );

    onCancel();
  };

  const getBody = () => {
    return (
      <div className="px-2 mt-5">
        <p className="text-base font-medium text-black font-poppins">
          Un-Retire this asset
        </p>
        <p className="mt-2 text-xs font-normal text-black font-aileron">
          Are you sure you want to un-retire this asset?
        </p>
      </div>
    );
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px" centered>
      <div className="w-full p-4 rounded-md">
        <div className="flex items-center justify-between">
          <CustomRoundedImage
            size="w-12 h-12"
            image={<UnRetireIcon size={24} className="text-white" />}
            background="bg-primary"
          />
          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        {getBody()}

        <div className="flex justify-end gap-x-3 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Cancel
          </Button>

          <Button colors="primary" size="primary" onClick={onConfirm}>
            Confirm
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default UnretireAssetModal;
